import { green } from "@ant-design/colors";
import { Button, Flex, Space, Typography } from "antd";
import React from "react";
import { CheckOutlined } from "@ant-design/icons";

export default function ChangeInfoSuccess() {
  return (
    <Flex justify="center" className="my-5">
      <Space direction="vertical" align="center">
        <Flex justify="center">
          <Button
            type="primary"
            style={{ background: green.primary }}
            shape="circle"
            size="large"
            icon={<CheckOutlined />}
          />
        </Flex>
        <Typography.Title level={3}>
          Yêu cầu điều chỉnh thông tin đã gửi thành công
        </Typography.Title>

        <div>
          Yêu cầu điều chỉnh thông tin của Quý khách đã được gửi đến FastCA, chờ
          kiểm tra và xác minh thông tin.
        </div>
        <div>
          Quý khách vui lòng kiểm tra Email để nhận kết quả xử lý yêu cầu
        </div>
      </Space>
    </Flex>
  );
}
